export const HEADER_SEARCH_TYPES = {
  BREEDERS: 'breeders',
  SHELTERS: 'shelters',
  BREED_GUIDES: 'breed_guides'
};

export const HEADER_SEARCH_TYPE_LABELS = {
  [HEADER_SEARCH_TYPES.BREEDERS]: 'Breeders',
  [HEADER_SEARCH_TYPES.SHELTERS]: 'Shelters & Rescues',
  [HEADER_SEARCH_TYPES.BREED_GUIDES]: 'Breed guides'
};

export const HEADER_SEARCH_TYPE_VALUES = Object.values(HEADER_SEARCH_TYPES);

export const HEADER_SEARCH_TYPE_LABEL_VALUES = Object.values(
  HEADER_SEARCH_TYPE_LABELS
);
